(() => {
 const getDestinations=menu=>{
  try{return JSON.parse(menu.querySelector('[data-tpl-search-destinations]')?.textContent||'[]');}catch{return [];}
 };
 const normalize=s=>window.TplCatalogueIndex.normalize(s);
 const matchesDestination=(item,query)=>{
  const words=normalize(query).split(' ').filter(Boolean);
  const names=[item.label,...(item.aliases||[])].map(normalize);
  return words.length>0&&names.some(name=>words.every(word=>name.includes(word))||name.replace(/ /g,'').includes(words.join('')));
 };

 const setupHint=(menu,input)=>{
  const hint=menu.querySelector('[data-tpl-search-hint]');
  const cube=hint?.querySelector('[data-tpl-search-cube]');
  const front=hint?.querySelector('[data-tpl-search-front]');
  const next=hint?.querySelector('[data-tpl-search-next]');
  if(!hint||!cube||!front||!next||hint.dataset.hintReady)return;
  const labels=(hint.dataset.searchTerms||'').split('|').filter(Boolean);
  const categories=labels.map(label=>({label}));
  const destinations=getDestinations(menu);
  const terms=[];
  for(let i=0;i<Math.max(categories.length,destinations.length);i++){
   if(categories[i])terms.push(categories[i]);
   if(destinations[i])terms.push(destinations[i]);
  }
  if(terms.length<2)return;
  hint.dataset.hintReady='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  let timer,turnTimer,resetFrame,current=0,composing=false;
  const stop=()=>{
   clearTimeout(timer);clearTimeout(turnTimer);cancelAnimationFrame(resetFrame);
  };
  const place=()=>{
   cube.classList.add('is-resetting');
   cube.classList.remove('is-turning');
   front.textContent=terms[current].label;
   next.textContent=terms[(current+1)%terms.length].label;
   resetFrame=requestAnimationFrame(()=>{resetFrame=requestAnimationFrame(()=>cube.classList.remove('is-resetting'));});
  };
  const active=()=>menu.isConnected&&menu.open&&!document.hidden&&!reduced.matches&&!composing&&input.value==='';
  const schedule=()=>{
   timer=setTimeout(()=>{
    if(!active()){sync();return;}
    cube.classList.add('is-turning');
    turnTimer=setTimeout(()=>{
     if(!active()){sync();return;}
     current=(current+1)%terms.length;
     place();schedule();
    },620);
   },2580);
  };
  const sync=()=>{
   stop();current=0;place();
   hint.hidden=!menu.open||input.value!==''||composing;
   if(active())schedule();
  };
  input.closest('form').classList.add('has-search-hint');
  input.addEventListener('input',sync);
  input.addEventListener('search',sync);
  input.addEventListener('compositionstart',()=>{composing=true;sync();});
  input.addEventListener('compositionend',()=>{composing=false;sync();});
  new MutationObserver(sync).observe(menu,{attributes:true,attributeFilter:['open']});
  document.addEventListener('visibilitychange',sync);
  reduced.addEventListener('change',sync);
  window.addEventListener('pagehide',stop);
  window.addEventListener('pageshow',sync);
  sync();
 };
 const init=()=>{
  const menu=document.getElementById('TplSiteMenu'),input=document.getElementById('TplSiteMenuSearch');
  const panel=menu?.querySelector('#TplMenuSearchIndex'),source=menu?.querySelector('[data-tpl-index-template]');
  if(!input||!panel||!source||input.dataset.indexReady)return;
  input.dataset.indexReady='true';input.setAttribute('aria-controls','TplMenuSearchIndex');input.setAttribute('aria-expanded','false');
  setupHint(menu,input);
  const grid=panel.querySelector('[data-tpl-index-grid]'),status=panel.querySelector('[data-tpl-index-status]'),retry=panel.querySelector('[data-tpl-index-retry]'),catalogue=window.TplCatalogueIndex.forMenu(menu);let cards,version='';
  const destinations=getDestinations(menu),destinationList=panel.querySelector('[data-tpl-search-destinations-list]');
  destinationList.setAttribute('aria-label',catalogue.copy.selection);
  const pageCache=new Map();
  let pageResults=[],pageLoading=false,pageError=false,pageRun=0,pageTimer,pageController;
  const pageKey=value=>{
   const url=new URL(value,location.origin);
   if(url.origin!==location.origin||!/(?:^|\/)pages\//.test(url.pathname))return null;
   return url.pathname.replace(/\/size-guide-full$/,'/size-guide-tpl');
  };
  const cancelPages=()=>{clearTimeout(pageTimer);pageController?.abort();pageController=null;pageRun++;pageLoading=false;};
  const filter=()=>{
   const state=catalogue.snapshot();
   const currentVersion=state.items.map(item=>item.id+':'+item.archive).join('|');
   if(!cards||version!==currentVersion){version=currentVersion;grid.replaceChildren();cards=state.items.map(item=>{const el=item.el.cloneNode(true);grid.append(el);return {...item,el};});}
   const words=normalize(input.value).split(' ').filter(Boolean);let count=0;
   for(const card of cards){const match=window.TplCatalogueIndex.matches(card,input.value);card.el.hidden=!match;if(match)count++;}
   const teeContext=panel.querySelector('[data-tpl-tee-context]');
   if(teeContext)teeContext.hidden=!( /(?:^|\W)(?:t[\s-]?shirts?|tees?)(?:$|\W)/i.test(input.value)&&cards.some(card=>String(card.id)==='8936782069938'&&!card.el.hidden));
   panel.querySelector('[data-tpl-index-title]').textContent=input.value.trim()?catalogue.copy.selection:catalogue.copy.view_all;
   const matches=destinations.filter(item=>matchesDestination(item,input.value));
   const seen=new Set(matches.map(item=>new URL(item.url,location.origin).pathname+new URL(item.url,location.origin).search));
   for(const item of pageResults){if(!seen.has(item.url)){seen.add(item.url);matches.push(item);}}
   destinationList.replaceChildren();
   for(const item of matches){
    const anchor=document.createElement('a');anchor.href=item.url;
    const name=document.createElement('span');name.textContent=item.label;anchor.append(name);
    if(item.soon){const soon=document.createElement('small');soon.textContent=panel.dataset.comingSoon;anchor.append(soon);}
    const arrow=document.createElement('span');arrow.textContent='↗';arrow.setAttribute('aria-hidden','true');anchor.append(arrow);
    destinationList.append(anchor);
   }
   destinationList.hidden=matches.length===0;
   const loading=state.loading||pageLoading,error=state.error||pageError;
   status.textContent=loading?catalogue.copy.loading:count+' '+panel.dataset.pieceLabel+(matches.length?' · '+matches.length+' '+panel.dataset.destinationLabel:'')+(error?' · '+catalogue.copy.incomplete:'');
   panel.setAttribute('aria-busy',String(loading));retry.hidden=!error;
   panel.querySelector('[data-tpl-index-empty]').hidden=loading||error||count>0||matches.length>0;
  };
  const refresh=()=>{const request=catalogue.load();filter();request.then(()=>{cards=null;if(!panel.hidden)filter();});};
  const searchPages=(immediate=false,force=false)=>{
   cancelPages();const query=input.value.trim(),run=pageRun;
   pageResults=[];pageError=false;pageLoading=query.length>=2;
   if(!force&&pageCache.has(query)){pageResults=pageCache.get(query);pageLoading=false;}
   filter();if(!pageLoading)return;
   pageTimer=setTimeout(async()=>{
    const controller=new AbortController();pageController=controller;
    try{
     const url=new URL(input.closest('form').action,location.origin);
     url.pathname=url.pathname.replace(/\/$/,'')+'/suggest.json';url.search='';
     url.searchParams.set('q',query);url.searchParams.set('resources[type]','page');url.searchParams.set('resources[limit]','10');url.searchParams.set('resources[options][fields]','title,body');
     const response=await fetch(url,{signal:controller.signal,headers:{Accept:'application/json'}});
     if(!response.ok)throw new Error('Page search unavailable');
     const data=await response.json();
     if(run!==pageRun||query!==input.value.trim()||panel.hidden)return;
     const results=data.resources?.results?.pages;
     if(!Array.isArray(results))throw new Error('Invalid page results');
     const canonical=results.filter(item=>item.handle!=='size-guide-full'||!results.some(other=>other.handle==='size-guide-tpl'));
     pageResults=canonical.map(item=>({label:item.title,url:pageKey(item.url)})).filter(item=>item.label&&item.url);
     pageCache.set(query,pageResults);if(pageCache.size>30)pageCache.delete(pageCache.keys().next().value);
    }catch(error){if(run!==pageRun||error.name==='AbortError')return;pageError=true;}
    finally{if(run===pageRun){pageLoading=false;pageController=null;if(!panel.hidden)filter();}}
   },immediate?0:180);
  };
  retry.addEventListener('click',()=>{refresh();searchPages(true,true);});
  const open=()=>{menu.classList.add('is-searching');panel.hidden=false;input.setAttribute('aria-expanded','true');refresh();searchPages(true);menu.querySelector('.tpl-site-menu__body').scrollTop=0;};
  const close=()=>{cancelPages();menu.classList.remove('is-searching');panel.hidden=true;input.setAttribute('aria-expanded','false');};
  input.addEventListener('focus',open);input.addEventListener('input',()=>{if(panel.hidden)open();else searchPages();});
  menu.addEventListener('keydown',event=>{
   if(panel.hidden||!['ArrowDown','ArrowUp'].includes(event.key))return;
   const links=[...destinationList.querySelectorAll('a[href]'),...grid.querySelectorAll('a[href]')].filter(el=>!el.closest('[hidden]')&&el.getClientRects().length);
   const index=links.indexOf(event.target);
   if(event.target!==input&&index<0)return;
   const next=event.key==='ArrowDown'?links[index+1]:index>0?links[index-1]:input;
   if(next){event.preventDefault();event.stopPropagation();next.focus();}
  });
  input.closest('form').addEventListener('submit',event=>{event.preventDefault();const query=normalize(input.value).replace(/ /g,'');const exact=destinations.find(item=>[item.label,...(item.aliases||[])].some(name=>normalize(name).replace(/ /g,'')===query));if(exact&&query){window.location.assign(exact.url);return;}open();});
  menu.addEventListener('click',event=>{const button=event.target.closest('[data-tpl-index-close]');if(!button||!panel.contains(button))return;event.preventDefault();close();menu.querySelector('.tpl-site-menu__body').scrollTop=0;menu.querySelector('[data-tpl-site-menu-close]').focus({preventScroll:true});});
  menu.addEventListener('close',close);
  document.addEventListener('click',event=>{if(event.target.closest('[data-tpl-site-search]'))requestAnimationFrame(()=>{if(menu.open)open();});});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();


